var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NuxtLink',{attrs:{"to":_setup.href,"aria-label":_setup.ariaLabel,"event":_vm.disabled ? '' : 'click'}},[_c('img',{class:{
            ['icon-logo-' + _setup.size + '-h']: true,
        },attrs:{"loading":_setup.loading,"src":_setup.getLogo,"alt":"Affility logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }